module.exports = __webpack_public_path__ + "static/media/fa-regular-400.e6c93cb4.eot";